<script>
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    export let page = 1;
    export let max = 1;
    export let show_pages = false;
    export let frame = 3; // can be bool false to show all

    $: pre_frame = get_pre_frame(page, max, frame);
    $: limit_pre_frame = frame && pre_frame && pre_frame.length == frame && pre_frame[0] != 1;

    $: post_frame = get_post_frame(page, max, frame);
    $: limit_post_frame = frame && post_frame && post_frame.length == frame && post_frame[frame - 1] != max;

    $: active_prev = pre_frame.length > 0;
    $: active_next = post_frame.length > 0;

    $: is_visible = show_pages && max > 1 && page <= max;

    $: check_limit(max);

    function check_limit(max) {
        if (page > max) {
            dispatch_change(max);
        }
    }

    function get_pre_frame(page, max, frame) {
        const to_max = limit(page, max) - 1;
        if (frame === false) {
            return get_frame(1, to_max);
        }
        return get_frame(limit(page - frame, max), to_max);
    }
    function get_post_frame(page, max, frame) {
        if (frame === false) {
            return get_frame(page + 1, limit(max, max));
        }
        return get_frame(page + 1, limit(page + frame, max));
    }

    function get_frame(from, to) {
        if (from > to) {
            return [];
        }
        if (from == to) {
            return [from];
        }
        return Array.from(Array(to - from + 1).keys()).map((i) => from + i);
    }

    function limit(value, max) {
        if (isNaN(value)) {
            return 1;
        }
        if (value < 1) {
            return 1;
        }
        if (value > max) {
            return max;
        }
        return value;
    }

    function prev() {
        dispatch_change(page - 1);
    }
    function next() {
        dispatch_change(page + 1);
    }
    function change(p) {
        dispatch_change(p);
    }

    function dispatch_change(p) {
        const new_page = limit(p);
        dispatch('change', {
            page: new_page,
        });
    }
</script>

{#if is_visible}
    <section>
        <button class="control" on:click={prev} title={window.__('paging.prev')} disabled={!active_prev}>
            <span class="btn icon icon-left" />
        </button>

        <div class="pages">
            {#if limit_pre_frame}
                <span class="limit">{@html window.__('paging.limit')}</span>
            {/if}
            {#each pre_frame as entry}
                <button class="pre" on:click={() => change(entry)}>{entry}</button>
            {/each}
            <span class="current">{page}</span>
            {#each post_frame as entry}
                <button class="post" on:click={() => change(entry)}>{entry}</button>
            {/each}
            {#if limit_post_frame}
                <span class="limit">{@html window.__('paging.limit')}</span>
            {/if}
        </div>
        <button class="control" on:click={next} title={window.__('paging.next')} disabled={!active_next}>
            <span class="btn icon icon-right" />
        </button>
    </section>
{/if}


<style>button {
    cursor: pointer;
}
section {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    margin: 0.5rem 0;
    margin-top: 30px;
}
.control {
    font-size: 1rem;
    line-height: 1rem;
    background: none;
    border: 0;
    display: inline-block;
    padding: 0.2rem;
    color: var(--color-primary);
}
.control:disabled {
    pointer-events: none;
}
.control:disabled .btn{
    background-color: rgba(0,0,0,0.5);
}
.pages {
    display: flex;
    flex-direction: row;
    margin: 0 0.5rem;
    align-items: center;
    justify-content: center;
    width: auto;
}
.pages span,
.pages button {
    font-size: 1rem;
    line-height: 1rem;
    background: none;
    border: 0;
    display: inline-block;
    padding: 0.2rem;
    margin: 0 0.2rem;
    padding: 10px 15px;
}


.pages span:hover,
.pages button:hover{
    background: rgba(0,0,0,0.2);
}
.pages .limit {
    opacity: 0.8;
}
.pages span:hover,
.pages button:hover{
    background: rgba(0,0,0,0.2);
}
.pages .current{
    font-weight: 800;
}
.pages button {
    color: var(--color-primary);
}

@media (max-width: 642px){
    .pages span,
    .pages button {
        font-size: 0.851rem;
        line-height: 1rem;
        background: none;
        border: 0;
        display: inline-block;
        padding: 0.2rem;
        margin: 0 0.2rem;
        padding: 5px 10px;
    }
}

@media (max-width: 455px){
    .pages span,
    .pages button {
        font-size: 0.758rem;
        line-height: 1rem;
        background: none;
        border: 0;
        display: inline-block;
        padding: 0.2rem;
        margin: 0 0.2rem;
        padding: 2px 5px;
    }
}
    .btn {
        width: 40px;
        height: auto;
        padding: 5px 0;
    }

    .control:disabled .btn {
        border-color: transparent;
    }
</style>